import React from 'react';
import { withTranslation, Trans } from 'react-i18next';
import DatePicker from "react-datepicker";
import * as styles from '../../../components/table/table.module.scss';
import * as cardsStyles from '../cards.module.scss';
import { utils } from '../../../utils/utils.js';
import ToggleButtonSimple from '../../../components/buttons/toggle_button_simple';
import SelectForProperty from '../../../components/inputs/selectForProperty';

class EditCardLimit extends React.Component {
    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.props.item);
        this.t = props.t;
        this.saveAction = this.saveAction.bind(this);
        this.updateLimit = this.updateLimit.bind(this);
        this.cancelEditLimit = this.cancelEditLimit.bind(this);
        this.toLimitStateName = this.toLimitStateName.bind(this);
    }

    cancelEditLimit(e) {
        e.preventDefault();
        this.setState(Object.assign({}, this.props.item));
        if (this.props.isNew) {
            this.props.removeAction(this.props.item);
        } else {
            this.props.cancelEditAction(this.state.limitId);
        }

    }

    saveAction(e) {
        e.preventDefault();
        const state = Object.assign({}, this.state);
        state.endDate = typeof (state.endDate) === "string" ? state.endDate : state.endDate.toISOString();
        this.setState(state);
        this.props.saveAction(state);
    }

    updateLimit(propName, value, dataType) {
        const state = Object.assign({}, this.state);

        state[propName] = this.convertValue(value, dataType);
        //for oil only
        if (propName === 'dateLimit') {
            state["dayLimit"] = this.convertValue(value, dataType);
            state["monthLimit"] = this.convertValue(value, dataType);
        }

        if (propName === 'movingTs') {
            state["endDate"] = this.convertValue(value, dataType);
        }

        this.setState(state);
    }

    convertValue(value, dataType) {
        if (dataType === "int") {
            return parseInt(value);
        }
        if (dataType === "float") {
            return parseFloat(value);
        }
        if (dataType === "date") {
            return utils.toLocalNetString(value);
        }

        return value;
    }

    toLimitStateName(value) {
        switch (value) {
            case 0:
                return this.props.i18n.t("Limits.notUseLimitState");
            case 1:
                return this.props.i18n.t("Limits.useLimitState");
            case 2:
                return this.props.i18n.t("Limits.stopSupplyState");
            default:
                return value;
        }
    }

    render() {
        return (
            <div className={cardsStyles.edit_card_limit_form}>
                <div className={cardsStyles.edit_card_limit_header}>
                    <div className={cardsStyles.button_container}>
                        <button className={cardsStyles.save_card_limit_btn} onClick={this.saveAction}></button>
                        <button className={cardsStyles.cancel_edit_card_limit_btn} onClick={this.cancelEditLimit}></button>
                    </div>
                </div>
                <div className={cardsStyles.edit_card_limit_body}>
                    <div>
                        <div>
                            <SelectForProperty
                                header={this.t("Limits.fuelType")}
                                onChange={(val) => this.updateLimit("fuelType", val)}
                                value={this.state.fuelType}
                                options={this.props.fuelTypes?.map(ft => { return { label: ft, value: ft } }) || []}
                            />
                        </div>
                        <div>
                            <SelectForProperty
                                header={this.t("Limits.limitState")}
                                onChange={(value) => this.updateLimit("limitState", value, "int")}
                                value={this.state.limitState}
                                options={[{ label: this.toLimitStateName(0), value: "0" }, { label: this.toLimitStateName(1), value: "1" }, { label: this.toLimitStateName(2), value: "2" }]}
                            />
                        </div>
                    </div>
                    <div>
                        <div>
                            <label><Trans>Limits.dateLimit</Trans></label>
                            <input type="number" step="0.1" value={this.state.dateLimit} onChange={(e) => {
                                this.updateLimit("dateLimit", e.target.value);
                                // this.updateLimit("dayLimit", e.target.value);
                                // this.updateLimit("monthLimit", e.target.value);
                            }
                            } />
                        </div>
                        <div>
                            <label><Trans>Limits.totalVolume</Trans></label>
                            <input type="number" step="0.1" readOnly value={this.state.totalVolume} onChange={(e) =>
                                this.updateLimit("totalVolume", e.target.value)} />
                        </div>
                    </div>
                    <div>
                        <div>
                            <label><Trans>Limits.movingTs</Trans></label>
                            <div className={styles.date_picker}>
                                <DatePicker dateFormat="dd-MM-yyyy" selected={new Date(this.state.movingTs.split('.')[0] + ".000Z")} onChange={date => this.updateLimit("movingTs", date, "date")} />
                            </div>
                        </div>
                        <div>
                            <label><Trans>Limits.movingNumber</Trans></label>
                            <input type="text" value={this.state.movingNumber} onChange={(e) =>
                                this.updateLimit("movingNumber", e.target.value)} />
                        </div>
                    </div>
                    <div>
                        <div>
                            <label><Trans>Limits.limitReal</Trans></label>
                            <ToggleButtonSimple className={cardsStyles.mt5} value={this.state.limitReal} onChange={() => this.updateLimit("limitReal", !this.state.limitReal)} />
                        </div>
                    </div>
                </div>
            </div>);
    }
}

export default withTranslation("translations")(EditCardLimit);
